import { render } from "./AddressItem.vue?vue&type=template&id=3dc19491&scoped=true"
import script from "./AddressItem.vue?vue&type=script&lang=ts"
export * from "./AddressItem.vue?vue&type=script&lang=ts"

import "./AddressItem.vue?vue&type=style&index=0&id=3dc19491&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3dc19491"

export default script